// src/components/ModalAvisoMorosidadFinanzas.js
import React from 'react';
import { FaFileInvoiceDollar } from 'react-icons/fa';
import './ModalAvisoMorosidadFinanzas.css';

const ModalAvisoMorosidadFinanzas = ({
    isOpen,
    onClose,
    adeudo = 0,
    numeroCasa = ''
}) => {
    if (!isOpen) return null;

    const formattedAdeudo = Number(adeudo || 0).toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    return (
        <div className="modal-aviso-finanzas-backdrop" onClick={onClose}>
            <div className="modal-aviso-finanzas-card" onClick={e => e.stopPropagation()}>
                <div className="modal-aviso-icon-container">
                    <FaFileInvoiceDollar />
                </div>

                {numeroCasa && (
                    <div className="modal-aviso-casa-badge">
                        Vivienda: Casa {numeroCasa}
                    </div>
                )}

                <h3>Aviso de Saldo Pendiente</h3>

                <p className="modal-aviso-mensaje">
                    Estimado(a) residente: Le informamos de manera cordial que presenta un saldo pendiente por liquidar.
                    Para poder utilizar todas las amenidades, servicios y funciones de la aplicación de forma normal, le
                    invitamos a realizar su pago a la brevedad.
                </p>

                <div className="modal-aviso-debt-box">
                    <span className="debt-label">Saldo total a liquidar:</span>
                    <span className="debt-value">${formattedAdeudo}</span>
                </div>

                <button
                    type="button"
                    className="modal-aviso-btn-entendido"
                    onClick={onClose}
                >
                    Entendido / Informado
                </button>
            </div>
        </div>
    );
};

export default ModalAvisoMorosidadFinanzas;
